import React from "react";
import { Search } from "@thecb/components";
import { useDispatch, useSelector } from "react-redux";
import { setSearchTerm } from "../AdministeredUsers.state";

const FilterToolbarForm = ({ field, actions }) => {
  const dispatch = useDispatch();
  const administeredUsersCache = useSelector(
    (state) => state.administeredUsers.usersCache.value
  );

  const usersSearchDataset =
    administeredUsersCache?.map((user) => ({
      name: `${user.firstName.value} ${user.lastName.value}`,
      email: user.email.value,
    })) ?? [];

  return (
    <Search
      ariaControlsId="users-table"
      disableFilter
      placeholder="Search by Name or Email Address"
      onSearchCallback={() => dispatch(setSearchTerm(field.rawValue))}
      onClearCallback={() => dispatch(setSearchTerm(""))}
      field={field}
      fieldActions={actions}
      dataset={usersSearchDataset}
      valuesToSearchFor={["name", "email"]}
      width="450px"
    />
  );
};

export default FilterToolbarForm;
